import React, { useRef, useState } from "react";
import { useTheme } from "next-themes";
import { toast, Toaster as Sonner, useSonner } from "sonner";
import { X } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();
	const { toasts } = useSonner();
	const [showDismissAll, setShowDismissAll] = useState(false);
	const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const handleMouseEnter = () => {
		if (hideTimerRef.current) {
			clearTimeout(hideTimerRef.current);
			hideTimerRef.current = null;
		}
		setShowDismissAll(true);
	};
	const handleMouseLeave = () => {
		hideTimerRef.current = setTimeout(() => setShowDismissAll(false), 600);
	};

	return (
		<div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			{toasts.length > 1 && (
				<button
					type="button"
					aria-label="Alle Benachrichtigungen schließen"
					data-testid="notifications-dismiss-all"
					onClick={() => toast.dismiss()}
					className={`fixed bottom-8 right-[404px] z-[10060] inline-flex items-center gap-1.5 rounded-full border border-border bg-background/90 px-3 py-1.5 text-xs font-medium text-foreground shadow-md backdrop-blur transition hover:bg-background hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
						showDismissAll
							? "pointer-events-auto opacity-100"
							: "pointer-events-none opacity-0"
					}`}
				>
					<X className="h-3.5 w-3.5" />
					Alle schließen
				</button>
			)}
			<Sonner
				theme={theme as ToasterProps["theme"]}
				position="bottom-right"
				visibleToasts={6}
				className="toaster group"
				toastOptions={{
					classNames: {
						toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
						description: "group-[.toast]:text-muted-foreground",
						closeButton:
							"pointer-events-none opacity-0 transition group-hover:pointer-events-auto group-hover:opacity-100 !rounded-full !border !border-border !bg-background/90 !text-foreground shadow-sm backdrop-blur hover:!bg-background hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
						actionButton:
							"group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
						cancelButton:
							"group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
					},
				}}
				{...props}
			/>
		</div>
	);
};

export { Toaster };
